import { Injectable } from '@angular/core';
import { DataSourceRequestState, DataResult, toDataSourceRequestString, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { HttpRepo } from '@shared/services/httprepo';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';
import { CommonMethods } from '@services/common.method';

@Injectable({
  providedIn: 'root'
})
export class FSliteTradeService {
  
  constructor(private auth: AuthService, private httpRepo:HttpRepo, private commonMethod: CommonMethods) {
      this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
  }
  public fetch(url: string, state: DataSourceRequestState, searchKey: string): Observable<any> {
    const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
    const hasGroups = state.group && state.group.length;
    return this.httpRepo.Get("trades", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
    }
  public addTrade(data): Observable<any> {
    data.ID = CommonMethods.GetID();
    return this.httpRepo.Post("trades", data) // Send the state to the server
  }
  public editTrade(data): Observable<any> {
    return this.httpRepo.Put("trades/" + data.ID, data) // Send the state to the server
  }
  public deleteTrade(data): Observable<any> {
   return this.httpRepo.Delete("trades/" + data.ID); // Send the state to the server
  }
  public addCategory(tradeID, data): Observable<any> {
     data.ID = CommonMethods.GetID();
    return this.httpRepo.Post("trades/" + tradeID + "/categories", data); // Send the state to the server
  }
  public editCategory(tradeID, data): Observable<any> {
    return this.httpRepo.Put("trades/" + tradeID + "/categories/" + data.ID, data) // Send the state to the server
  }
  public deleteCategory(data): Observable<any> {
    return this.httpRepo.Delete("trades/" + data.ParentID+"/categories/"+data.ID) // Send the state to the server
  }
  public addSubCategory(tradeID, categoryID, data): Observable<any> {
    data.ID = CommonMethods.GetID();
    return this.httpRepo.Post("trades/" + tradeID + "/categories/" + categoryID + "/subcategories", data) // Send the state to the server
  }
  public editSubCategory(tradeID, categoryID, data): Observable<any> {
    return this.httpRepo.Put("trades/" + tradeID + "/categories/" + categoryID + "/subcategories/"+data.ID, data) // Send the state to the server
  }
  public deleteSubCategory(TradeID,data): Observable<any> {
   return this.httpRepo.Delete("trades/" + TradeID+"/categories/"+data.ParentID+"/subcategories/"+data.ID) // Send the state to the server
  } 
  public UploadImage(formData){
    return this.httpRepo.PostFile("categoryimage",formData) // Send the state to the server
  }
}
